var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImageCancel = function SvgImageCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.9 6 6 9.9l6.1 6.1L6 22.1 9.9 26l6.1-6.1 6.1 6.1 3.9-3.9-6.1-6.1L26 9.9 22.1 6 16 12.1zM16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0"
  })));
};
export { SvgImageCancel as ReactComponent };
export default __webpack_public_path__ + "assets/ImageCancel.8c43a0e387d83f69cef5fa81f43959fc.svg";